import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getArrayDocDataByID,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getRefFromId,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import { useAppContext } from "../config/AppContext.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import createDocApi from "../api/database/createDocApi.js";
import { DatePicker, TimePicker } from "antd";
import { useSnackbar } from "notistack";
import { addActivityLog } from "../config/OnlineStatus.js";
import dayjs from "dayjs";
import RangeTimePickerGPT0 from "../textfields/RangeTimePickerGPT0.js";
import DatePickerGPT0 from "../textfields/DatePickerGPT0.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import MLTFGPT3 from "../textfields/MLTFGPT3.js";
import TextField2T from "../textfields/TextField2T.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import DropDownGPTMulti from "../dropdowns/DropDownGPTMulti.js";
import DropDownGPTM3 from "../dropdowns/DropDownGPTM3.js";

const AddTask = ({ folder, userData, orgData, onClose, onUpdate }) => {
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingData = false, setLoadingData] = useState(false);
  const [users_assigned, setUsersAssigned] = useState([]);
  const [users, setUsers] = useState([]);
  const [taskContent, setTaskContent] = useState("");
  const [taskTitle, setTaskTitle] = useState("");

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleFetchData = async () => {
    if (orgData) {
      let users = await getArrayDocDataByID("user", orgData.users_id);
      setUsersAssigned(
        folder?.members_id?.length > 0 ? [folder?.members_id[0]] : []
      );
      setUsers(
        users.map((u) => ({
          value: u.id,
          label: u.display_name || u.email,
        }))
      );
    }
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);

  const handleAddTask = async () => {
    setLoadingData(true);
    let body = {
      master_id: folder?.master_id || orgData.id,
      users_id: users_assigned,
      author_user_id: userData.id,
      title: taskTitle,
      content: taskContent,
      creation_date: getFlutterTime(),
      folder_ref: folder?.ref,
      done: false,
      seen_by: [userData.id],
      comments: [],
    };
    await createDocApi("task", body, prefix);

    handleClickVariant("Tâche ajoutée avec succès", "success");

    await onUpdate();
    onClose();
    setLoadingData(false);
  };

  return (
    <div className="flex flex-col  bg-white  border-2  rounded-3xl w-c400 ">
      <div className=" text-h3  flex flex-row justify-between p-4 border-b-1">
        Ajouter une tâche
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>

      <div className="flex flex-col bg-neutral-50 gap-2 p-4">
        <div className=" text-h3 text-shadow_50">
          Sélectionnez un opérateur et détaillez la tâche à réaliser,
          l'opérateur verra la tâche sur son application mobile.
        </div>

        <DropDownGPTM3
          label="Membres assignés"
          value={users_assigned}
          items={users}
          className="bg-white w-full"
          onChange={(value) => setUsersAssigned(value)}
        ></DropDownGPTM3>

        <TextField2T
          value={taskTitle}
          onChange={(e) => setTaskTitle(e.target.value)}
          label="Titre de la tâche"
          placeholder="Entrez le titre de la tâche"
          className="w-full"
        ></TextField2T>

        <MLTFGPT3
          value={taskContent}
          onChange={(e) => setTaskContent(e.target.value)}
          label="Détail de la tâche"
          placeholder="Décrivez la tâche à réaliser"
        ></MLTFGPT3>
      </div>
      <div className="flex flex-row gap-2 justify-end p-4 border-t-1">
        <SecondaryButton onClick={onClose}>Annuler</SecondaryButton>
        <PrimaryButton
          onClick={handleAddTask}
          disabled={
            loadingData || !taskTitle || !taskContent || !users_assigned
          }
        >
          Ajouter la tâche <SmallSpinner loading={loadingData} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default AddTask;
